export default __webpack_public_path__ + "static/media/ic_cost.b4a729d3.svg";